export const apiEndpoint = { 
    pdfBaseUri: "https://pdf-uat.meon.co.in",
    esignBaseUri: window.location.host.includes("localhost") ?  "http://127.0.0.1:8000" : "https://esignuat.meon.co.in",
    kycBaseUri: window.location.host.includes("localhost") ?  "https://livetest.meon.co.in" : "https://livetest.meon.co.in",
}
